import { useMemo, useRef } from 'react';

let webSocketInstance: WebSocket | null = null;
let webSocketCompanyIdentity: string | null = null;

export const deleteWebSocket = () => {
  if (webSocketInstance) {
    webSocketInstance.close();
    webSocketInstance = null;
    webSocketCompanyIdentity = null;
  }
};

const useWebSocket = (route: string) => {
  const companyIdentity = window.localStorage.getItem('__company_id');
  const retainedWebSocket = useRef<WebSocket | null>(webSocketInstance);
  const exportWebSocket = useMemo(() => {
    const token = window.localStorage.getItem('__token');
    if (!token) {
      if (!retainedWebSocket.current) {
        throw new Error('An authenticated session is required to create a WebSocket');
      }
      return retainedWebSocket.current;
    }
    if (webSocketInstance && webSocketCompanyIdentity !== companyIdentity) {
      deleteWebSocket();
    }
    if (!webSocketInstance) {
      webSocketInstance = new WebSocket(`${import.meta.env.VITE_WS_SERVER}?token=${token}`);
      webSocketCompanyIdentity = companyIdentity;
      // biome-ignore lint/suspicious/noConsole: <explanation>
      console.log(`Creating WebSocket instance: {route: ${route}}...`);
    } else {
      // biome-ignore lint/suspicious/noConsole: <explanation>
      console.log(`Reusing existing WebSocket instance: {route: ${route}}...`);
    }
    retainedWebSocket.current = webSocketInstance;
    return webSocketInstance;
  }, [companyIdentity, route]);

  return { exportWebSocket, deleteWebSocket };
};

export default useWebSocket;
